module.exports = __webpack_public_path__ + "img/products_big_can_original_uae.98c817f3.png";